import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Container,
} from "@mui/material";

export default function DemoSection() {
  return (
    <Box
      sx={{
        width: "100%",
        py: 10,
        px: 4,
        backgroundColor: "#0f0f0f",
        color: "white",
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={6}
          alignItems="center"
          justifyContent="space-between"
        >
          {/* LEFT SIDE */}
          <Grid item size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: 600, lineHeight: 1.2, mb: 3 }}
            >
              Take control of your operations. Transform the way your restaurant
              works.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                lineHeight: 1.3,
                maxWidth: "80%",
              }}
            >
              Want to see how our POS can streamline billing, orders, and
              inventory? We’re here to guide you.
            </Typography>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item size={{ xs: 12, md: 5 }}>
            <Typography variant="body1" sx={{ mb: 2, opacity: 0.8 }}>
              Our team will contact you within 12 hours to schedule a
              personalized demo.
            </Typography>

            <TextField
              fullWidth
              placeholder="Mobile Number"
              variant="outlined"
              autoComplete="off"
              type="number"
              sx={{
                mb: 3,
                input: { color: "#fff" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#333" },
                  "&:hover fieldset": { borderColor: "#555" },
                },
              }}
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                py: 1.3,
                fontSize: "1rem",
                backgroundColor: "#f6521a",
                borderRadius: 1.5,
                textTransform: "none",
                "&:hover": { backgroundColor: "#f13d04" },
              }}
            >
              Schedule a Demo
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
